import { render, staticRenderFns } from "./TrTextBlockWithInputImpr.vue?vue&type=template&id=6a28c0f4&scoped=true&"
import script from "./TrTextBlockWithInputImpr.vue?vue&type=script&lang=js&"
export * from "./TrTextBlockWithInputImpr.vue?vue&type=script&lang=js&"
import style0 from "./TrTextBlockWithInputImpr.vue?vue&type=style&index=0&id=6a28c0f4&lang=scss&scoped=true&"
import style1 from "./TrTextBlockWithInputImpr.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28c0f4",
  null
  
)

export default component.exports